<header class="app-header shadow-soft">
  <div class="left">
    <button
      pButton
      type="button"
      class="p-button-text menu-toggle"
      (click)="onToggleMenu()"
      aria-label="Alternar menu"
      [attr.aria-expanded]="!collapsed()"
    >
      <i [ngClass]="collapsed() ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'"></i>
    </button>
  </div>

  <div class="spacer"></div>

  <div class="right">
    <div class="notificacao-wrapper">
      <button
        type="button"
        class="icon-btn"
        aria-label="Notificações"
        [attr.aria-expanded]="visibleNotificacoes()"
        (click)="toggleNotificacoes()"
      >
        <i class="pi pi-bell"></i>

        <span *ngIf="naoLidas() > 0" class="notificacao-badge">
          {{ naoLidas() }}
        </span>
      </button>

      <div class="painel-notificacoes" *ngIf="visibleNotificacoes()">
        <div class="painel-header">
          <span>Notificações</span>

          <div class="painel-acoes">
            <button
              *ngIf="naoLidas() > 0"
              type="button"
              class="marcar-todas-btn"
              (click)="marcarTodasComoLidas()"
            >
              Marcar todas
            </button>

            <button
              type="button"
              class="fechar-btn"
              aria-label="Fechar notificações"
              (click)="fecharNotificacoes()"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>
        </div>

        <div class="painel-body">
          <div
            *ngFor="let notificacao of notificacoes()"
            class="notificacao-item"
            [class.nao-lida]="!notificacao.lida"
            (click)="marcarComoLida(notificacao.id)"
          >
            <div class="notificacao-topo">
              <span class="tipo-indicador" [ngClass]="getTipoClass(notificacao.tipo)"></span>
              <span class="notificacao-titulo">{{ notificacao.titulo }}</span>
              <span class="notificacao-tempo">{{ notificacao.tempo }}</span>
            </div>

            <div class="notificacao-mensagem">
              {{ notificacao.mensagem }}
            </div>
          </div>

          <div *ngIf="notificacoes().length === 0" class="notificacao-vazia">
            Nenhuma notificação no momento.
          </div>
        </div>
      </div>
    </div>

    <a
      class="partner-badge"
      href="#"
      target="_blank"
      rel="noopener"
      aria-label="Abrir site da Avalara"
    >
      <img src="img/avalara-logo-2.png" alt="Avalara" class="avalara-logo" />
      <span class="partner-caption hide-sm">Online</span>
    </a>

    <div class="user-actions">
      <span class="usuario-nome hide-sm" *ngIf="usuarioLogado">{{ usuarioLogado }}</span>
      <button pButton icon="pi pi-sign-out" severity="secondary" [text]="true" (click)="onLogout()" title="Sair" aria-label="Sair"></button>
    </div>
  </div>
</header>